export const LOCAL_STORAGE = {
  AUTH_DETAILS: 'authDetails',
  GRID_CONFIGS: 'gridConfigs',
  CURRENT_USER: 'currentUser',
  LAST_URL: 'lastUrl',
  MASTER_ACTIVE_TAB: 'masterDataActiveTab',
  REPORTS_ACTIVE_TAB: 'reportsDataActiveTab',
  PRE_AUTH_ADVANCE_SEARCH: 'preAuthAdvanceSearch',
  CURRENT_LANGUAGE: 'current-language',
  ADVANCE_PRE_AUTH_SEARCH: 'advancePreAuthSearch',
  SEARCH_CLAIM: 'searchClaim',
  CLAIM_UPLOADS: 'claimUploads',
  PREPARE_CLAIM: 'prepareClaim',
  CONVERT_CLAIM: 'convertClaim',
  ELIGIBILITY_TRANSACTION: 'eligibilityTransaction',
  DENIAL_MANAGEMENT: 'denialManagement',
  CREATEPAYMENT: 'createPayment',
  CLAIM_UPLOADS_HISTORY: 'claimHistory',
  PRESCRIPTION_TRANSACTION_LIST: 'prescriptionTransaction',
  PREAUTH_TRANSACTION_ACTIVE_TAB: 'preauth-transactionActiveTab',
  ADVANCE_PREAUTH_TRANSACTION_ACTIVE_TAB: 'advance-preauth-transactionActiveTab',
  CLAIM_TRANSACTION_ACTIVE_TAB: 'claim-transactionActiveTab',
  PRESCRIPTION_TRANSACTION_ACTIVE_TAB: 'prescription-transactionActiveTab',
  BENEFICIARY_LIST: 'beneficiaryFilter',
  PATIENT_POLICY_LIST: 'patientPolicyListFilter',
  PATIENT_CLAIM_LIST: 'patientClaimListFilter',
  PATIENT_PRESCRIPTION_LIST: 'patientPrescriptionListFilter',
  PATIENT_PREAUTH_LIST: 'patientPreAuthListFilter',
  CLAIM_REIMBURSEMENT: 'claimreimbursementFilter',
  PATIENT_CLAIM_REIMBURSEMENT_LIST: 'patientclaimReimbursementFilter',
  CLAIM_BATCH_LIST_FILTERS: 'claimbatchlistfilters',
  PROVIDER_BATCH_LIST_FILTERS: 'providerbatchlistfilters'
};
